import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { playingAreaConfig } from "./utils.js";

const Pitch = (props) => {
  const playingArea = useMemo(() => {
    const { height, width, full, half } = playingAreaConfig[props.sport];
    const playingAreaFull = full({
      fillColor: props.fillColor,
      height,
      isLandscape: props.isLandscape,
      strokeColor: props.strokeColor,
      strokeWidth: props.strokeWidth,
      width
    });
    const playingAreaHalf = half({
      fillColor: props.fillColor,
      fullPitchView: props.fullPitchView,
      height,
      width,
      strokeColor: props.strokeColor,
      strokeWidth: props.strokeWidth
    });
    return { width, height, full: playingAreaFull, half: playingAreaHalf };
  }, [
    props.sport,
    props.fillColor,
    props.fullPitchView,
    props.isLandscape,
    props.strokeColor,
    props.strokeWidth
  ]);

  return (
    <g className="playingArea">
      <g>{playingArea.half}</g>
      {props.fullPitchView && (
        <>
          <g transform={`translate(${playingArea.width}, 0) scale(-1, 1)`}>
            {playingArea.half}
          </g>
          {playingArea.full}
        </>
      )}
    </g>
  );
};

Pitch.propTypes = {
  fillColor: PropTypes.string,
  fullPitchView: PropTypes.bool,
  isLandscape: PropTypes.bool,
  sport: PropTypes.string,
  strokeColor: PropTypes.string,
  strokeWidth: PropTypes.number
};

Pitch.defaultProps = {
  fillColor: null,
  fullPitchView: false,
  isLandscape: false,
  sport: "soccer",
  strokeColor: null,
  strokeWidth: 2
};

export default Pitch;
